<template>
  <div
    class="form-group-simple"
    :class="{
      'form-group-simple--completed': completed
    }"
  >
    <label for="BSN">{{ label }}</label>

    <input
      id="bsn"
      :class="errorMessage ? 'error' : ''"
      v-model="inputValue"
      type="text"
      name="bsn"
      maxlength="9"
      placeholder="012345672"
      @input="update($event.target.value)"
      @blur="blur"
    />
    <div class="form-group-simple__details" v-if="errorMessage">
      <div class="form-group-simple__messages">
        <div class="form-group-simple__error">
          <span> <v-error-icon></v-error-icon> {{ errorMessage }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useField } from 'vee-validate';
import { ref, onBeforeMount, watch, getCurrentInstance } from 'vue';
import VErrorIcon from 'icons/AlertCircle';
import { generateYupSchemaForBsn } from '@/components/shared/validationRules/bsnValidationRules';

export default {
  name: 'VInputBsnSimple',
  components: {
    VErrorIcon
  },
  props: {
    id: {
      default: '',
      type: String
    },
    autofocus: {
      default: false,
      type: Boolean
    },
    name: {
      default: 'BSN',
      type: String
    },
    label: {
      default: '',
      type: String
    },
    rules: {
      default: null,
      type: Object
    },
    error: {
      default: false,
      type: Boolean
    }
  },
  setup(props) {
    const instance = getCurrentInstance();
    const inputValue = ref(props.value);
    const schema = ref(generateYupSchemaForBsn(props));
    const { value, errorMessage, validate } = useField(props.id, schema);

    watch(
      () => props.rules,
      () => {
        schema.value = generateYupSchemaForBsn(props);
      }
    );
    const completed = ref(false);
    const focus = () => {};

    const blur = () => {
      validate();
    };

    const update = async (updatedValue) => {
      value.value = updatedValue;
      inputValue.value = updatedValue;
      let result = await validate();
      instance.emit('updateValidation', result.valid);
    };

    onBeforeMount(() => {
      if (props.value) {
        value.value = ref(props.value);
      }
    });

    return {
      inputValue,
      completed,
      focus,
      blur,
      update,
      errorMessage
    };
  },
  data() {
    return {
      bsn: '',
      errors: '',
      showError: false
    };
  }
};
</script>
<style lang="scss" scoped>
.error {
  border: 1px solid $pure-red;
}
.form-group-simple {
  position: relative;
  &__error .alert-circle-icon {
    display: inline-flex;
    width: 16px;
    height: 16px;
    fill: $pure-red;
    vertical-align: bottom;
  }
}
</style>
